import * as Utils from 'utils';

export const orderChecklistMiddleware = () => (next) => (currentAction) => {
  let action = {...currentAction};
  let data = {};

  if (currentAction.type === 'project/setChecklist') {
    if (localStorage.getItem('isFromCheckoutPage') && window['orderPageLoadConfig'] && Object.keys(window['orderPageLoadConfig']).length) {
      data = window['orderPageLoadConfig'];

      const checklistById = Utils.arrayToObjectByKey(data.checklist, 'id');
      const checklistCopy = action.payload.map(checklistItem => {
        if (checklistById[checklistItem.id]) {
          return {
            ...checklistItem,
            optionsCheckedByDefault: checklistById[checklistItem.id].options.map(option => option.id),
            options: checklistItem.options.map(option => {
              const optionMatch = checklistById[checklistItem.id].options.find(opt => opt.id === option.id);
              if (optionMatch) {
                return {
                  ...option,
                  ...optionMatch
                }
              }
              return option;
            })
          }
        }
        return checklistItem;
      });

      setTimeout(() => {
        localStorage.removeItem('isFromCheckoutPage')
      }, 1500);

      action = {
        ...action,
        payload: checklistCopy
      };
    }
  }
  next(action);
}
